import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { createCustomElement } from '@angular/elements';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LetModule, PushModule } from '@ngrx/component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { EventEffects } from 'app/event/features/event.effects';
import { reducer, eventFeatureKey  } from 'app/event/features/event.reducer';

import { CoreModule } from 'app/core/core.module';
import { DialogModule } from 'app/dialog/dialog.module';
import { ToastModule } from 'app/toast/toast.module';

import { IconModule } from '../icon/icon.module';

import {ClipboardModule} from '@angular/cdk/clipboard';
import {LayoutModule} from '@angular/cdk/layout';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { ChatModule } from '../chat/chat.module';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { NgxCurrencyInputMode, provideEnvironmentNgxCurrency, NgxCurrencyDirective } from "ngx-currency";
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { PendingComponent } from './components/pending/pending.component';
import { AddPendingComponent, oldStyledCurrencyDirective } from './components/modal/add-pending/add-pending.component';
import { UpdatingCartComponentComponent } from './updating-cart-component/updating-cart-component.component';
import { UpdateCartModalComponent } from './components/modal/update-cart-modal/update-cart-modal.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { MdbAccordionModule } from 'mdb-angular-ui-kit/accordion';
import { AddOnDonationComponent } from './components/modal/add-on-donation/add-on-donation.component';
import { MdbInputGoogleMapsAutocompleteComponent } from 'app/core/components/mdb-input-google-maps-autocomplete/mdb-input-google-maps-autocomplete.component';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
@NgModule({
  declarations: [
    PendingComponent,
    AddPendingComponent,
    AddOnDonationComponent,
    oldStyledCurrencyDirective,
    UpdatingCartComponentComponent,
    UpdateCartModalComponent
  ],
  imports: [
    MdbInputGoogleMapsAutocompleteComponent,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    LetModule,
    PushModule,
    StoreModule.forRoot({}, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    StoreModule.forFeature(eventFeatureKey, reducer),
    EffectsModule.forRoot([]),
    EffectsModule.forFeature([EventEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    CoreModule,
    DialogModule,
    ToastModule,
    IconModule,
    ClipboardModule,
    LayoutModule,
    ScrollingModule,
    NgScrollbarModule,
    AngularCropperjsModule,
    ChatModule,
    DragDropModule,
    MdbTooltipModule,
    MdbFormsModule,
    MdbPopoverModule,
    MdbSelectModule,
    MdbAccordionModule,
    NgxCurrencyDirective,
    MdbAutocompleteModule
  ],
  providers: [provideEnvironmentNgxCurrency({
    align: "left",
    allowNegative: false,
    allowZero: true,
    decimal: ".",
    precision: 0,
    prefix: "$ ",
    suffix: "",
    thousands: ",",
    nullable: true,
    min: null,
    max: null,
    inputMode: NgxCurrencyInputMode.Financial
  })],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [PendingComponent]
})
export class ReportsModule {
  constructor(injector: Injector) {
    const ReportPendingElement = createCustomElement(PendingComponent, {injector});
    const UpdateCartElement = createCustomElement(UpdatingCartComponentComponent, {injector});
    const UpdateCartModal = createCustomElement(UpdateCartModalComponent, {injector});

    try {
      customElements.define('paybee-report-pending-element', ReportPendingElement);
      customElements.define('paybee-update-cart-element', UpdateCartElement);
      customElements.define('paybee-update-cart--modal-element', UpdateCartModal);
    } catch(e) {}
  }
}
